<template>
    <!-- User Profile Communication Info Tab Content View From Account Profile -->
    <div class="tabs-content-firstblock">
        <div class="row" v-if="ajax_call_in_progress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                </div>
            </div>
        </div>
        <div v-else class="row contact-communication">
            <div class="col-lg-12">
                <div class="ml-2 mr-1 mb-3">
                    <div class="infoHeader pb-4">
                        <!-- <div class="a-q-Jc-j-contactView mt-1">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView left-text-width-comm">Business Email</div>
                                <div class="w-100">
                                    <div class="d-flex justify-content-end align-items-center action-button-icons"
                                        v-if="edit_primary_email && (communication_data.primary_email.length == 0 || communication_data.primary_email_verified == false)" style="position: absolute;top:10px">
                                        <div class="pointer" @click="resetValue('primary_email')">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div class="ml-2 pointer">
                                            <img src="/static/images/close.svg">
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center action-button-icons" v-if="edit_primary_email" style="position: absolute;right:19px;top:45px">
                                        <span class="fs-13 text-right d-block">{{(communication_data.primary_email).length}}/320</span>
                                    </div>
                                    <el-tooltip class="item" effect="dark" content="Click to edit"
                                            placement="top">
                                    <input name="primary_email" class="inputField" v-validate="'required|email'"
                                        @focus="editValue('primary_email')" style="padding-top: 6px !important;"
                                        :readonly="!edit_primary_email"
                                        v-model="communication_data.primary_email">
                                    </el-tooltip>
                                    <span class="validation" v-show="errors.has('primary_email')">
                                        {{errors.first('primary_email')}}
                                    </span>
                                </div>
                            </div>
                        </div> -->
                        <div class="a-q-Jc-j-contactView mt-1">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView left-text-width-comm">Primary Email</div>
                                <div class="w-100">
                                    <div class="d-flex justify-content-end align-items-center action-button-icons"
                                        style="position: absolute;top:10px">
                                        <div v-if="edit_primary_email && (communication_data.primary_email_verified == false)" class="pointer" @click="resetValue('primary_email', '0')">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div v-if="edit_primary_email && (communication_data.primary_email_verified == false)" class="ml-2 pointer" @click="addUpdateCommunicationData('primary_email', '0')">
                                            <img src="/static/images/close.svg">
                                        </div>
                                        <div v-if="edit_primary_email == false && communication_data.primary_email != '' && communication_data.primary_email_verified == false" class="pointer" @click="sendOtpForPhoneEmail('primary_email_verify')">
                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/verify-phone.svg"
                                                    width="14px">
                                        </div>
                                        <div v-if="edit_primary_email == false && communication_data.primary_email != '' && communication_data.primary_email_verified == true" class="pointer">
                                            <i class="icon icon-check-circle fs-24 text-success ml-2"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center action-button-icons" v-if="edit_primary_email" style="position: absolute;right:19px;top:45px">
                                        <span class="fs-13 text-right d-block">{{(communication_data.primary_email).length}}/320</span>
                                    </div>
                                    <!-- <el-tooltip class="item" effect="dark" content="Click to edit"
                                            placement="top"> -->
                                    <!-- <input name="primary_email" class="inputField" v-validate="'required|email'"
                                        @focus="editValue('primary_email')" style="padding-top: 6px !important;"
                                        :readonly="true"
                                        v-model="communication_data.primary_email"> -->
                                        <input @click="editValue('primary_email')" name="primary_email" class="inputField" v-validate="'email'"
                                        style="padding-top: 6px !important;"
                                        :readonly="communication_data.primary_email_verified == true"
                                        v-model="communication_data.primary_email">
                                    <!-- </el-tooltip> -->
                                    <span class="validation" v-show="errors.has('primary_email')">
                                        {{errors.first('primary_email')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="infoHeader mt-4 pb-4">
                            <div class="a-q-Jc-j-contactView" style="position: relative;" v-for="(email, emailindex) in communication_data.alternate_emails"
                                :key="'email'+emailindex">
                                <div class="a-q-Jc-Pj-Ya-contactView">
                                    <div v-if="communication_data.alternate_emails.length == 1" class="a-q-Jc-bj-contactView left-text-width-comm">Alternate Email</div>
                                    <div v-else class="a-q-Jc-bj-contactView left-text-width-comm">Alternate Email - {{emailindex+1}}</div>
                                    <div class="w-100">
                                        <div>
                                            <div v-if="edit_alternate_email == true && alternate_email_index == emailindex" class="d-flex justify-content-end align-items-center action-button-icons"
                                                style="position: absolute;top:8px;right:69px;">
                                                <div class="pointer" @click="resetValue('alternate_email',emailindex)">
                                                    <img src="/static/images/check.svg">
                                                </div>
                                                <div class="ml-2 pointer" @click="addUpdateCommunicationData('alternate_email', emailindex)">
                                                    <img src="/static/images/close.svg">
                                                </div>
                                            </div>
                                            <div v-if="edit_alternate_email == true && alternate_email_index == emailindex" class="d-flex justify-content-end align-items-center action-button-icons"
                                                style="position: absolute;top:8px;right:10px;">
                                                <div class="pointer" @click="removeAltEmailCell(emailindex)">
                                                    <img src="/static/images/ios-remove-circle@2x.png" style="width:20px;margin-right:5px" alt="">
                                                </div>
                                                <div class="pointer" @click="addAltEmailCell()">
                                                    <img src="/static/images/ios-add-circle@2x.png" style="width:20px" alt="">
                                                </div>
                                            </div>
                                            <div v-if="edit_alternate_email == true && alternate_email_index == emailindex" class="d-flex justify-content-end align-items-center action-button-icons" style="position: absolute;right:19px;top:42px">
                                                <span class="fs-13 text-right d-block">{{communication_data.alternate_emails[emailindex].email.length}}/320</span>
                                            </div>
                                            <el-tooltip class="item" effect="dark" content="Click to edit"
                                            placement="top">
                                            <input class="inputField" @focus="editValue('alternate_email', emailindex)" :readonly="!edit_alternate_email" v-validate="'email'" :id="'alternate_email_input'+emailindex" data-vv-as="Alternate Email" :name="'alternate_email_input'+emailindex"
                                            style="padding-top: 6px !important;"
                                            v-model="communication_data.alternate_emails[emailindex].email" />
                                            </el-tooltip>
                                             <span class="invalid-feedback-form text-danger text-left d-block mt-0 fs-12"
                                                v-show="errors.has('alternate_email_input'+emailindex)">{{errors.first('alternate_email_input'+emailindex)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView" v-for="(phone, phoneindex) in communication_data.phone_details"
                            :key="'phone'+phoneindex">
                            <div v-if="phone.is_primary == true" class="a-q-Jc-Pj-Ya-contactView" style="display:flex;align-items:center">
                                <div class="a-q-Jc-bj-contactView left-text-width-comm">
                                    Primary Contact Number
                                </div>
                                <div class="w-100">
                                    <div class="profile-primay-phone" style="position: relative;">
                                        <div @click="editValue('phone_number', phoneindex)">
                                            <el-tooltip class="item" effect="dark" content="Click to edit"
                                                placement="top">
                                                <vue-tel-input
                                                    @open="editValue('phone_number', phoneindex)"
                                                    @input="editValue('phone_number', phoneindex)"
                                                    @click="editValue('phone_number', phoneindex)"
                                                    :disabled="phone.primary_phone_verified == true || $route.params.id != loggedInUser.user_id"
                                                    :enabledCountryCode="false"
                                                    :name="'phone'+phoneindex"
                                                    :disabledFormatting="false" :validCharactersOnly="true"
                                                    :maxLen="maxPhoneLength" class="teleContact w-100" ref="telInput"
                                                    placeholder="Enter your Phone Number" v-validate="{min:10}"
                                                    v-model="communication_data.phone_details[phoneindex].phone_number">
                                                </vue-tel-input>
                                            </el-tooltip>
                                        </div>
                                        <div v-if="edit_phone_number == true && phone.primary_phone_verified == false" class="d-flex justify-content-end align-items-center action-button-icons pointer" style="position: absolute;bottom:45px;right: 0">
                                            <div v-if="phone.primary_phone_verified == false" class="pointer" @click="resetValue('phone_number', phoneindex)">
                                                <img src="/static/images/check.svg">
                                            </div>
                                            <div v-if="phone.primary_phone_verified == false" @click="addUpdateCommunicationData('primary_phone', phoneindex)" class="ml-2 pointer">
                                                <img src="/static/images/close.svg">
                                            </div>
                                        </div>
                                        <div v-if="edit_phone_number == false && communication_data.phone_details[phoneindex].phone_number != '' && phone.primary_phone_verified == false" class="d-flex justify-content-end align-items-center action-button-icons pointer" style="position: absolute;bottom:45px;right: 0">
                                            <div class="pointer" @click="sendOtpForPhoneEmail('primary_phone_verify')">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/verify-phone.svg"
                                                        width="14px">
                                            </div>
                                        </div>
                                        <div style="position: absolute;bottom:0px;right: 0" v-if="communication_data.phone_details[phoneindex].phone_number != '' && phone.primary_phone_verified == true">
                                            <i class="icon icon-check-circle fs-24 text-success ml-2"></i>
                                        </div>
                                        <div style="position: absolute;">
                                            <span class="invalid-feedback-form text-danger text-left d-block mt-0 fs-12"
                                            v-show="errors.has('phone'+phoneindex)">{{errors.first('phone'+phoneindex)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView" v-for="(phone,altphoneindex) in communication_data.phone_details"
                            :key="'altphone'+altphoneindex">
                            <div v-if="phone.is_primary == false" class="a-q-Jc-Pj-Ya-contactView" style="align-items:center;padding-bottom: 12px !important;">
                                <div v-if="altphoneindex ==1" class="a-q-Jc-bj-contactView left-text-width-comm">
                                    Alternate Contact Number
                                    <sup class="fs-14 ml-1 mandatory">
                                        <el-tooltip class="item" effect="dark"
                                            content="The options for this field are configurable in the Settings page"
                                            placement="right">
                                            <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                        </el-tooltip>
                                    </sup>
                                </div>
                                <div :style="{marginLeft: altphoneindex>1 ? '250px !important' : '0 !important', marginBottom: altphoneindex>1 ? '10px !important' : '0 !important'}" class="leftType ml-0">
                                    <div class="d-flex">
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Home'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Mobile'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/mobile-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Whatsapp'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/whatsapp-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Line'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/line-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Work'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/work-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Telegram'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/telegram-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Others'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/others-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Messenger'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/messenger-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <img v-if="communication_data.phone_details[altphoneindex].phone_type == 'Fax'"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/fax-contact-icon.svg"
                                            style="margin-right: 10px;" />
                                        <multiselect v-validate="'required'" v-model="communication_data.phone_details[altphoneindex].phone_type"
                                            class="digi-multiselect overflow-multiselect pointer" style="width: 128px" id="ajax"
                                            :options="['Home','Work','Mobile','Fax','Others','Whatsapp','Messenger','Telegram','Line']"
                                            :multiple="false" :searchable="true" :internal-search="true"
                                            @open="editValue('alternate_phone_number', altphoneindex)"
                                            :disabled="$route.params.id != loggedInUser.user_id"
                                            :show-labels="false"
                                            :clear-on-select="false" :close-on-select="true" :options-limit="280"
                                            :max-height="200" :show-no-results="true" :hide-selected="false">
                                            <template slot="option" slot-scope="{ option }">
                                                <div class="d-flex flex-row">
                                                    <img v-if="option == 'Home'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Mobile'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/mobile-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Whatsapp'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/whatsapp-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Line'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/line-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Work'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/work-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Telegram'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/telegram-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Others'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/others-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Messenger'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/messenger-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <img v-if="option == 'Fax'"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/fax-contact-icon.svg"
                                                        style="margin-right: 10px;" />
                                                    <span class="ml-2">
                                                        <span style="font-size: 12px">{{ option }}</span>
                                                    </span>
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div :style="{marginBottom: altphoneindex>1 ? '10px !important' : '0 !important'}" class="profile-primay-phone ml-6 w-100" style="position: relative;">
                                    <div @click="editValue('alternate_phone_number', altphoneindex)">
                                        <el-tooltip class="item" effect="dark" content="Click to edit"
                                            placement="top">
                                            <vue-tel-input
                                                @open="editValue('alternate_phone_number', altphoneindex)"
                                                @input="editValue('alternate_phone_number', altphoneindex)"
                                                :name="'alternate_phone'+altphoneindex"
                                                :disabled="$route.params.id != loggedInUser.user_id" :enabledCountryCode="false"
                                                :disabledFormatting="false" :validCharactersOnly="true" :maxLen="maxPhoneLength"
                                                class="teleContact w-100" ref="telInput"
                                                placeholder="Enter your alternate Phone Number"
                                                data-vv-as="Alternate Phone"
                                                v-validate="{min:10}"
                                                v-model="communication_data.phone_details[altphoneindex].phone_number">
                                            </vue-tel-input>
                                        </el-tooltip>
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center action-button-icons pointer"
                                        style="position: absolute;bottom:30px;right:0px;">
                                        <div v-if="communication_data.phone_details[altphoneindex].phone_type == 'Whatsapp' && edit_alternate_phone_number == false">
                                            <img class="ml-2"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Whatsapp.svg"
                                                style="height:19px">
                                        </div>
                                        <div v-if="communication_data.phone_details[altphoneindex].phone_type == 'Line' && edit_alternate_phone_number == false">
                                            <img class="ml-2"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/line.svg"
                                                style="height:19px">
                                        </div>
                                        <div v-if="(communication_data.phone_details[altphoneindex].phone_type == 'Work' || communication_data.phone_details[altphoneindex].phone_type == 'Home' || communication_data.phone_details[altphoneindex].phone_type == 'Mobile') && edit_alternate_phone_number == false">
                                            <img class="ml-2"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/message.svg">
                                        </div>
                                        <div v-if="(communication_data.phone_details[altphoneindex].phone_type == 'Work' || communication_data.phone_details[altphoneindex].phone_type == 'Home' || communication_data.phone_details[altphoneindex].phone_type == 'Mobile') && edit_alternate_phone_number == false">
                                            <img class="ml-2"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/phone.svg">
                                        </div>
                                        <div v-if="edit_alternate_phone_number == true && alternate_phone_index == altphoneindex" @click="resetValue('alternate_phone_number', altphoneindex)">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div v-if="edit_alternate_phone_number == true && alternate_phone_index == altphoneindex" @click="addUpdateCommunicationData('alternate_phone_number', altphoneindex)" class="ml-2 pointer">
                                            <img src="/static/images/close.svg">
                                        </div>
                                        <div v-if="edit_alternate_phone_number == true && alternate_phone_index == altphoneindex" class="d-flex align-items-center ml-5" style="margin-right:5px;" @click="deletePhoneNumber(phone, altphoneindex)">
                                            <img src="/static/images/ios-remove-circle@2x.png" style="width:15px;" alt="">
                                        </div>
                                        <div v-if="edit_alternate_phone_number == true && alternate_phone_index == altphoneindex" class="d-flex align-items-center" @click="addPhoneNumber(altphoneindex)">
                                            <img src="/static/images/ios-add-circle@2x.png" style="width:15px;" alt="">
                                        </div>
                                    </div>
                                    <div style="position: absolute;">
                                        <span class="invalid-feedback-form text-danger text-left d-block mt-0 fs-12"
                                        v-show="errors.has('alternate_phone'+altphoneindex)">{{errors.first('alternate_phone'+altphoneindex)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="infoHeader mt-4 pb-4 contact-communication-emregency-contact" style="position: relative;">
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView">Emergency Contact</div>
                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView" style="overflow: auto;">
                                <table class="table table-noborder">
                                    <thead>
                                        <tr>
                                            <th>
                                                <input v-model="emergency_contact_checkbox_all" type="checkbox" name="checked_all" id="checked_all" />
                                            </th>
                                            <th>Contact Name</th>
                                            <th>Contact Number</th>
                                            <th>Relationship</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(emergencyContact,emergcontindex) in  communication_data.emergency_contact" :key="'emergeCont'+emergcontindex">
                                            <td>
                                                <!-- <input type="checkbox" v-model="emergency_contact_checkbox" :name="'checkbox'+index" :id="'checkbox'+index" /> -->
                                                <input type="checkbox" :checked="emergency_contact_checkbox_all" @change="contactChecked" :value="emergencyContact.id" :name="'checkbox'+emergcontindex" :id="'checkbox'+emergcontindex" />
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-center" style="position: relative;">
                                                    <el-tooltip class="item" effect="dark" content="Click to edit"
                                                        placement="top">
                                                        <input class="inputField" @focus="editValue('emergency_contact_name', emergcontindex)"
                                                            style="padding-top: 6px !important;width:200px;"
                                                            :readonly="!edit_emergency_contact_name"
                                                            v-validate="'required'"
                                                            data-vv-as="Contact Name"
                                                            :name="'emergency_contact_name'+emergcontindex"
                                                            v-model="communication_data.emergency_contact[emergcontindex].contact_name">
                                                    </el-tooltip>
                                                    <div v-if="edit_emergency_contact_name == true && emergency_contact_name_index == emergcontindex" class="d-flex pl-2 align-items-center">
                                                        <div class="pointer" @click="resetValue('emergency_contact_name', emergcontindex)">
                                                            <img src="/static/images/check.svg">
                                                        </div>
                                                        <div class="ml-2 pointer" @click="addUpdateCommunicationData('emergency_contact_name', emergcontindex)">
                                                            <img src="/static/images/close.svg">
                                                        </div>
                                                    </div>
                                                    <div style="position: absolute;bottom: -20px;">
                                                        <span class="invalid-feedback-form text-danger text-left d-block mt-0 fs-12"
                                                        v-show="errors.has('emergency_contact_name'+emergcontindex)">{{errors.first('emergency_contact_name'+emergcontindex)}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-center" style="position: relative;">
                                                    <div @click="editValue('emergency_number', emergcontindex)">
                                                        <el-tooltip class="item" effect="dark" content="Click to edit"
                                                            placement="top">
                                                            <vue-tel-input @open="editValue('emergency_number', emergcontindex)"
                                                            @input="editValue('emergency_number', emergcontindex)"
                                                            :disabled="$route.params.id != loggedInUser.user_id" :enabledCountryCode="false"
                                                            :disabledFormatting="false" :validCharactersOnly="true" :maxLen="maxPhoneLength"
                                                            class="teleContact1" :name="'emergency_number'+emergcontindex" ref="telInput"
                                                            placeholder="Enter your emergency phone number"
                                                            data-vv-as="Emergency Number"
                                                            v-validate="{min:10}"
                                                            v-model="communication_data.emergency_contact[emergcontindex].contact_number.phone_number"></vue-tel-input>
                                                        </el-tooltip>
                                                    </div>
                                                    <img class="ml-2"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/message.svg">
                                                    <img class="ml-2"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/phone.svg">
                                                    <div v-if="edit_emergency_number == true && emergency_number_index == emergcontindex" class="d-flex align-items-center">
                                                        <div class="d-flex pl-2 align-items-center">
                                                            <div class="pointer" @click="resetValue('emergency_number', emergcontindex)">
                                                                <img src="/static/images/check.svg">
                                                            </div>
                                                            <div class="ml-2 pointer" @click="addUpdateCommunicationData('emergency_number', emergcontindex)">
                                                                <img src="/static/images/close.svg">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style="position: absolute;bottom: -20px;">
                                                        <span class="invalid-feedback-form text-danger text-left d-block mt-0 fs-12"
                                                        v-show="errors.has('emergency_number'+emergcontindex)">{{errors.first('emergency_number'+emergcontindex)}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-center" style="position: relative;">
                                                    <el-tooltip class="item" effect="dark" content="Click to edit"
                                                        placement="top">
                                                        <multiselect v-model="communication_data.emergency_contact[emergcontindex].contact_relationship"
                                                            @open="getDropdownsDataByType('relationship', emergcontindex)"
                                                            :disabled="$route.params.id != loggedInUser.user_id"
                                                            class="digi-multiselect overflow-multiselect pointer" id="ajax"
                                                            :options="emergency_relationship_options"
                                                            :loading="dropdown_loading"
                                                            style="width: 126px;"
                                                            :multiple="false" :searchable="true" :internal-search="true"
                                                            :show-labels="false"
                                                            v-validate="'required'"
                                                            :name="'emergency_relationship'+emergcontindex"
                                                            data-vv-as="Relationship"
                                                            :clear-on-select="false" :close-on-select="true"
                                                            :options-limit="280" :max-height="200" :show-no-results="true"
                                                            :hide-selected="false">
                                                        </multiselect>
                                                    </el-tooltip>
                                                    <div v-if="edit_emergency_relationship == true && relationship_index == emergcontindex" class="d-flex pl-2 align-items-center">
                                                        <div class="pointer" @click="resetValue('emergency_relationship', emergcontindex)">
                                                            <img src="/static/images/check.svg">
                                                        </div>
                                                        <div class="ml-2 pointer" @click="addUpdateCommunicationData('emergency_relationship', emergcontindex)">
                                                            <img src="/static/images/close.svg">
                                                        </div>
                                                    </div>
                                                    <div style="position: absolute;bottom: -20px;">
                                                        <span class="invalid-feedback-form text-danger text-left d-block mt-0 fs-12"
                                                        v-show="errors.has('emergency_relationship'+emergcontindex)">{{errors.first('emergency_relationship'+emergcontindex)}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <div v-if="communication_data.emergency_contact.length == emergcontindex+1 && $route.params.id == loggedInUser.user_id" style="position: absolute; right: 0; bottom: -45px;">
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <div v-if="emergcontindex > 0 && checkedCheckbox.length <= 0" class="pointer">
                                                        <button class="btn btn-danger" @click="deletePeriod(emergcontindex)">-Delete Contact</button>
                                                    </div>
                                                    <div v-if="checkedCheckbox.length > 0" class="pointer">
                                                        <button class="btn btn-danger" @click="deleteEmergencyCon">-Delete Contacts</button>
                                                    </div>
                                                    <div class="ml-2 pointer">
                                                        <button class="btn btn-secondary" @click="addPeriod">+Add Contact</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    <div class="infoHeader pb-4" :class="{'mt-13': $route.params.id == loggedInUser.user_id, 'mt-4':$route.params.id != loggedInUser.user_id}">
                        <div class="a-q-Jc-j-contactView" v-for="(media, socialindex) in communication_data.social_media"
                            :key="'media'+socialindex">
                            <div class="a-q-Jc-Pj-Ya-contactView align-items-center">
                                <div class="a-q-Jc-bj-contactView left-text-width-comm">
                                    Social Media
                                    <sup class="fs-14 ml-1 mandatory">
                                        <el-tooltip class="item" effect="dark"
                                            content="The options for this field are configurable in the Settings page"
                                            placement="right">
                                            <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                        </el-tooltip>
                                    </sup>
                                </div>
                                <div class="d-flex align-items-center">
                                    <img v-if="communication_data.social_media[socialindex].account_type.type === 'Facebook'"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Facebook.svg"
                                        style="margin-right: 10px;width: 20px;" />
                                    <img v-if="communication_data.social_media[socialindex].account_type.type === 'twitter'"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/twitterr.svg"
                                        style="margin-right: 10px;width: 20px;" />
                                    <img v-if="communication_data.social_media[socialindex].account_type.type === 'Linkedin'"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/LinkedIn.svg"
                                        style="margin-right: 10px;width: 20px;" />
                                    <img v-if="communication_data.social_media[socialindex].account_type.type === 'Reddit'"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Reddit.svg"
                                        style="margin-right: 10px;width: 20px;" />
                                    <img v-if="communication_data.social_media[socialindex].account_type.type === 'Instagram'"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/insta.svg"
                                        style="margin-right: 10px;width: 20px;" />
                                    <multiselect v-validate="'required'" v-model="communication_data.social_media[socialindex].account_type"
                                        class="digi-multiselect overflow-multiselect pointer" id="ajax"
                                        @open="getDropdownsDataByType('social_media', socialindex)"
                                        label="type"
                                        :disabled="$route.params.id != loggedInUser.user_id"
                                        style="width: 150px;"
                                        :loading="dropdown_loading"
                                        :options="social_media_type_options"
                                        :show-labels="false"
                                        :multiple="false" :searchable="true" :internal-search="true"
                                        :clear-on-select="false" :close-on-select="true" :options-limit="280"
                                        :max-height="200" :show-no-results="true" :hide-selected="false">
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">No Social Media Types Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>


                                <div class="d-flex align-items-center ml-2 w-100">
                                    <div class="w-100 p-2" style="position: relative;">
                                        <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex justify-content-end align-items-center action-button-icons"
                                            style="position: absolute;top:18px;right:10px">
                                            <div v-if="edit_account_url == true && social_media_index == socialindex" class="pointer" @click="resetValue('account_url', socialindex)">
                                                <img src="/static/images/check.svg">
                                            </div>
                                            <div v-if="edit_account_url == true && social_media_index == socialindex" class="ml-2 pointer" @click="addUpdateCommunicationData('social_media', socialindex)">
                                                <img src="/static/images/close.svg">
                                            </div>
                                            <div v-if="socialindex > 0" class="d-flex align-items-center ml-5 pointer" @click="deleteSocialMedia(media.id, socialindex)">
                                                <img src="/static/images/ios-remove-circle@2x.png" style="width:15px;" alt="">
                                            </div>
                                            <div v-if="communication_data.social_media.length == socialindex+1" class="d-flex align-items-center pointer ml-3" @click="addSocialMedia(socialindex)">
                                                <img src="/static/images/ios-add-circle@2x.png" style="width:15px;" alt="">
                                            </div>
                                        </div>
                                        <el-tooltip class="item" effect="dark" content="Click to edit"
                                            placement="top">
                                            <!-- <a :href="media.account_url" target="_blank"
                      class="a-q-Jc-wg-contactView">{{ media.account_url || "-" }}</a> -->
                                            <!-- <a :href="media.account_url" target="_blank"
                      class="a-q-Jc-wg-contactView"> -->
                                            <input @focus="editValue('account_url', socialindex)" class="inputField"
                                                style="padding-top: 6px !important"
                                                :readonly="!edit_account_url"
                                                :name="'social_account_url'+socialindex"
                                                data-vv-as="Social URL"
                                                v-validate="'url'"
                                                v-model="communication_data.social_media[socialindex].account_url">
                                        </el-tooltip>
                                        <div class="invalid-feedback-form font-weight-bold" style="margin-top: 4px !important;color: #ff3b3b; position: absolute;" v-show="errors.has('social_account_url'+socialindex)">{{ errors.first("social_account_url"+socialindex) }}</div>
                                    </div>
                                    <!-- <div class="w-100 p-2" style="position: relative;" v-if="edit_account_url == false">
                                        <el-tooltip class="item" effect="dark" :content="media.account_url"
                                            placement="bottom">
                                            <input class="inputField" @click="edit_account_url = true"
                                                style="padding-top: 6px !important"
                                                readonly
                                                v-model="media.account_url">
                                        </el-tooltip>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <verify-phone v-if="showVerifyModal" modal_name="verify_phone" :emailPhoneVerify="emailPhoneVerify" @verfiy="verifyOtp"
            :phone="communication_data.phone_details[0].phone_number.startsWith('+91') ? communication_data.phone_details[0].phone_number.split(' ').splice(1,).join('') : communication_data.phone_details[0].phone_number" :email="communication_data.primary_email" @close="showVerifyModal = false">
        </verify-phone>
        <verify-phone-success v-if="verify_phone_success" :emailPhoneVerify="emailPhoneVerify" @deactivateEditMode="deactivateEditMode" :phone="communication_data.phone_details[0].phone_number.startsWith('+91') ? communication_data.phone_details[0].phone_number.split(' ').splice(1,).join('') : communication_data.phone_details[0].phone_number" :email="communication_data.primary_email" :login_id="loggedInUser.login_id" modal_name="verify_phone_success"></verify-phone-success>
    </div>
</template>
<script>
    import VerifyPhone from "./alertModals/VerifyPhone";
    import profile from "./mixins/profile";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import globals from './globals';
    import VerifyPhoneSuccess from './alertModals/VerifyPhoneSuccess.vue';
    export default {
        props: [],
        mixins: [profile],
        components: {
            HalfCircleSpinner,
            VerifyPhone,
            VerifyPhoneSuccess
        },
        data() {
            return {
                ajax_call_in_progress: false,
                verify_phone_success: false,
                edit_primary_email: false,
                edit_alternate_email: false,
                edit_phone_number: false,
                edit_alternate_phone_number: false,
                edit_emergency_number: false,
                edit_emergency_relationship: false,
                edit_account_url: false,
                edit_emergency_contact_name: false,
                dropdown_loading: false,
                emergency_contact_name_index: 0,
                emergency_number_index: 0,
                relationship_index: 0,
                emergency_relationship_options: [],
                maxPhoneLength: 15,
                edit_communication_data: {},
                user_data: {},
                alternate_email_input: [{
                    email: ''
                }],
                alternate_email_index: 0,
                new_primary_phone: '',
                new_alternate_phone_number: '',
                alternate_phone_type: '',
                alternate_phone_type: 'Work',
                social_media_type: 'Facebook',
                emergency_contact_checkbox_all: false,
                emergency_contact_checkbox: false,
                social_media_url: '',
                // alternate_phone: {
                //     phone: '',
                //     phone_type:''
                // },
                communication_data: {
                    alternate_emails: [{
                        email: ''
                    }],
                    emergency_contact: [
                        {
                            contact_name: "",
                            contact_number: {
                                country_code: "IN",
                                dial_code: "91",
                                phone_number: ""
                            },
                            contact_relationship: "",
                        },
                    ],
                    phone_details: [
                        {
                            country_code: "IN",
                            dial_code: "91",
                            is_primary: true,
                            phone_number: "",
                            phone_type: "Primary",
                            primary_phone_verified: false,
                        },
                        {
                            country_code: "IN",
                            dial_code: "91",
                            is_primary: false,
                            phone_number: "",
                            phone_type: "Work",
                            primary_phone_verified: false,
                        }
                    ],
                    primary_email: "",
                    primary_email_verified: false,
                    social_media: []
                },
                showVerifyModal: false,
                social_media_type_options: [],
                emailPhoneVerify: '',
                checkedCheckbox: [],
                alternate_phone_index: 0,
                social_media_index: 0
            }
        },
        methods: {
            async sendOtpForPhoneEmail(otpfor) {
                this.emailPhoneVerify = otpfor;
                let res = await this.$http.post(globals.AUTH_SERVICE + "/auth/otp", {
                    login_id: otpfor == 'primary_phone_verify' ? this.communication_data.phone_details[0].phone_number.startsWith('+91') ? this.communication_data.phone_details[0].phone_number.split(" ").splice(1,).join('') : this.communication_data.phone_details[0].phone_number : this.communication_data.primary_email,
                    otp_for: otpfor,
                    user_id: this.loggedInUser.user_id
                });
                if (res.data.status_id == 1) {
                    this.showVerifyModal = true;
                    setTimeout(() => {
                        this.$modal.show("verify_phone");
                    }, 500);
                }
            },
            async verifyOtp() {
                this.showVerifyModal = false;
                this.verify_phone_success = true;
                setTimeout(() => {
                    this.$modal.show("verify_phone_success");
                }, 500);
            },
            deactivateEditMode() {
                this.verify_phone_success = false;
                setTimeout(() => {
                    this.getCommunicationData();
                }, 500);
            },
            showAlternateEmmailEdit(ind) {
                this.alternate_email_index = ind;
                this.edit_alternate_email = true;
                setTimeout(() => {
                    $("#alternate_email_input"+ind).focus();
                }, 500);
            },
            addPhoneNumber() {
                this.communication_data.phone_details.push(
                    {
                        country_code: "IN",
                        dial_code: "91",
                        is_primary: false,
                        phone_number: "",
                        phone_type: "Work",
                        primary_phone_verified: false,
                    }
                );
            },
            async deletePhoneNumber(data, index) {
                if(data.id) {
                    try {
                        let response = await this.deleteCommunicationPhoneById(data.id);
                        if(response.status_id == 1) {
                            this.getCommunicationData();
                        }
                    }
                    catch(err) {
                    }
                } else {
                    this.communication_data.phone_details.splice(index,1);
                }
            },
            addAltEmailCell() {
                this.communication_data.alternate_emails.push({
                    email: ''
                });
            },
            removeAltEmailCell(index) {
                this.communication_data.alternate_emails.splice(index,1);
                this.addUpdateCommunicationData('alternate_email', index);
            },
            addSocialMedia(index) {
                this.communication_data.social_media.push(
                    {
                        account_type: {
                            type: 'Facebook',
                            icon_url: 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Facebook.svg'
                        },
                        account_url: ''
                    }
                );
            },
            editUser(obj, index) {
                if (obj == 'alternate_email') {
                    this.alternate_email_index = index;
                    this.edit_alternate_email = true;
                    // setTimeout(() => {
                    //     $("#alternate_email_input"+index).focus();
                    // }, 500);
                }
            },
            editValue(obj, index) {
                if(this.$route.params.id == this.loggedInUser.user_id) {
                    if (obj == 'primary_email' && this.communication_data.primary_email_verified == false) {
                        this.edit_primary_email = true;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = false;
                    } else if (obj == 'alternate_email') {
                        this.alternate_email_index = index;
                        this.edit_primary_email = false;
                        this.edit_alternate_email = true;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = false;
                    } else if (obj == 'phone_number') {
                        this.edit_primary_email = false;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = true;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = false;
                    } else if (obj == 'alternate_phone_number') {
                        this.alternate_phone_index = index;
                        this.edit_primary_email = false;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = true;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = false;
                    } else if (obj == 'emergency_number') {
                        this.emergency_number_index = index;
                        this.edit_primary_email = false;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = true;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = false;
                    } else if (obj == 'emergency_relationship') {
                        this.relationship_index = index;
                        this.edit_primary_email = false;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = true;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = false;
                    } else if (obj == 'account_url') {
                        this.social_media_index = index;
                        this.edit_primary_email = false;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = true;
                        this.edit_emergency_contact_name = false;
                    } else if (obj == 'emergency_contact_name') {
                        this.emergency_contact_name_index = index;
                        this.edit_primary_email = false;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = true;
                    }
                }
            },
            resetValue(obj, index) {
                let user_data = JSON.parse(localStorage.getItem('comm_data'));
                if (obj == 'primary_email') {
                    this.edit_primary_email = false;
                    this.communication_data.primary_email = user_data.primary_email == undefined || null ? '' : user_data.primary_email;
                } else if (obj == 'alternate_email') {
                    this.alternate_email_index = index;
                    this.edit_alternate_email = false;
                    this.communication_data.alternate_emails[index].email = user_data.alternate_emails[index] == undefined || null ? '' : user_data.alternate_emails[index];
                } else if (obj == 'phone_number') {
                    this.edit_phone_number = false;
                    this.communication_data.phone_details[index].phone_number = user_data.phone_details[index] == undefined || null ? '' : user_data.phone_details[index].phone_number
                } else if (obj == 'alternate_phone_number') {
                    this.edit_alternate_phone_number = false;
                    this.communication_data.phone_details[index].phone_number = user_data.phone_details[index] == undefined || null ? '' : user_data.phone_details[index].phone_number
                } else if (obj == 'emergency_number') {
                    this.edit_emergency_number = false;
                    this.communication_data.emergency_contact[index].contact_number.phone_number = user_data.emergency_contact[index] == undefined || null ? '' : user_data.emergency_contact[index].contact_number.phone_number
                } else if (obj == 'emergency_relationship') {
                    this.edit_emergency_relationship = false;
                    this.communication_data.emergency_contact[index].contact_relationship = user_data.emergency_contact[index] == undefined || null ? '' : user_data.emergency_contact[index].contact_relationship
                } else if (obj == 'account_url') {
                    this.edit_account_url = false;
                    // console.log(user_data.social_media[index]);
                    this.communication_data.social_media[index].account_url = user_data.social_media[index] == undefined || null ? '' : user_data.social_media[index].account_url
                } else if (obj == 'emergency_contact_name') {
                    this.edit_emergency_contact_name = false;
                    this.communication_data.emergency_contact[index].contact_name = user_data.emergency_contact[index] == undefined || null ? '' : user_data.emergency_contact[index].contact_name
                }
            },
            addPeriod(){
                this.communication_data.emergency_contact.push(
                    {
                        contact_name: "",
                        contact_number: {
                            country_code: "IN",
                            dial_code: "91",
                            phone_number: ""
                        },
                        contact_relationship: "",
                    }
                );
            },
            contactChecked(data){
                if(data.target.checked) {
                    if(data.target.value != '') {
                        this.checkedCheckbox.push(data.target.value);
                    }
                } else {
                    const index = this.checkedCheckbox.indexOf(data.target.value);
                    if (index > -1) {
                        this.checkedCheckbox.splice(index, 1);
                    }
                }
            },
            deletePeriod(index){
                this.communication_data.emergency_contact.splice(index,1);
                this.emergency_contact_checkbox_all = false;
                this.emergency_contact_checkbox = false;
            },
            async deleteEmergencyCon(){
                try {
                    let params = {
                        id: this.checkedCheckbox
                    }
                    let response = await this.deleteCommunicationEmergencyContactById(params);
                    if(response.status_id == 1) {
                        this.getCommunicationData();
                    }
                }
                catch(err) {

                }
            },
            async getCommunicationData() {
                this.ajax_call_in_progress = true;
                try {
                    let param = this.$route.params.id ? this.$route.params.id : this.loggedInUser.user_id;
                    let response = await this.getCommunication(param);
                    if(response.status_id == 1) {
                        localStorage.setItem('comm_data', JSON.stringify(response.response));
                        this.edit_primary_email = false;
                        this.edit_alternate_email = false;
                        this.edit_phone_number = false;
                        this.edit_alternate_phone_number = false;
                        this.edit_emergency_number = false;
                        this.edit_emergency_relationship = false;
                        this.edit_account_url = false;
                        this.edit_emergency_contact_name = false;
                        this.emergency_contact_checkbox_all = false;
                        this.emergency_contact_checkbox = false;
                        this.user_data = response.response;
                        this.communication_data.primary_email = this.user_data.primary_email;
                        this.communication_data.primary_email_verified = this.user_data.primary_email_verified;
                        this.communication_data.alternate_emails = this.user_data.alternate_emails;
                        this.communication_data.emergency_contact = this.user_data.emergency_contact;
                        this.communication_data.phone_details = this.user_data.phone_details;
                        // this.communication_data.social_media = this.user_data.social_media;

                        if(this.user_data.alternate_emails.length == 0) {
                            this.communication_data.alternate_emails = [{
                                email: ''
                            }];
                        } else {
                            this.user_data.alternate_emails.forEach((value, index)=>{
                                this.communication_data.alternate_emails[index] = {
                                    email: value
                                };
                            })
                        }
                        if(this.communication_data.emergency_contact.length == 0) {
                            this.communication_data.emergency_contact = [{
                                contact_name: "",
                                contact_number: {
                                    country_code: "IN",
                                    dial_code: "91",
                                    phone_number: ""
                                },
                                contact_relationship: "",
                            }];
                        }
                        if(this.user_data.social_media.length == 0) {
                            this.communication_data.social_media = [{
                                account_type: {
                                    type: 'Facebook',
                                    icon_url: 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Facebook.svg'
                                },
                                account_url: "",
                            }];
                        } else {
                            this.communication_data.social_media = [];
                            this.user_data.social_media.forEach((el, index)=>{
                                this.communication_data.social_media.push({
                                    account_type: {
                                        type: el.account_type,
                                        icon_url: el.icon_url
                                    },
                                    account_url: el.account_url,
                                    id: el.id,
                                })
                            })
                        }
                        if(this.communication_data.phone_details.length == 0) {
                            this.communication_data.phone_details = [
                                {
                                    country_code: "IN",
                                    dial_code: "91",
                                    is_primary: true,
                                    phone_number: "",
                                    phone_type: "Primary",
                                    primary_phone_verified: false,
                                },
                                {
                                    country_code: "IN",
                                    dial_code: "91",
                                    is_primary: false,
                                    phone_number: "",
                                    phone_type: "Work",
                                    primary_phone_verified: false,
                                }
                            ];
                        }
                        else {
                            if(this.communication_data.phone_details[0].is_primary == true && this.communication_data.phone_details.length == 1) {
                                this.communication_data.phone_details.push({
                                    country_code: "IN",
                                    dial_code: "91",
                                    is_primary: false,
                                    phone_number: "",
                                    phone_type: "Work",
                                    primary_phone_verified: false,
                                });
                            }
                            // else {
                            //     this.communication_data.phone_details.unshift({
                            //         country_code: "IN",
                            //         dial_code: "91",
                            //         is_primary: true,
                            //         phone_number: "",
                            //         phone_type: "Primary",
                            //         primary_phone_verified: false,
                            //     });
                            // }
                        }
                        this.ajax_call_in_progress = false;
                    }
                }
                catch(err) {
                    // console.log(err);
                }
            },
            async addUpdateCommunicationData(data, index) {
                try {
                    let params = {
                        alternate_emails: [],
                    }
                    if(data == 'primary_email') {
                        params.primary_email = this.communication_data.primary_email;
                        delete params.alternate_emails;
                        this.$validator.validate('primary_email').then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Enter Valid Email");
                            }
                        });
                    } else if(data == 'alternate_email') {
                        this.communication_data.alternate_emails.forEach((value, index)=>{
                            params.alternate_emails.push(value.email);
                        })
                        params.alternate_emails = params.alternate_emails.filter(item => item);
                        this.$validator.validate('alternate_email_input'+index).then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Enter Valid Alternate Email");
                            }
                        });
                    } else if(data == 'primary_phone') {
                        delete params.alternate_emails;
                        if(this.communication_data.phone_details[index].id) {
                            params.phone_details = [
                                {
                                    phone_type: 'primary',
                                    phone_number: this.communication_data.phone_details[index].phone_number.startsWith('+91') ? this.communication_data.phone_details[index].phone_number.split(' ').splice(1,).join('') : this.communication_data.phone_details[index].phone_number,
                                    country_code: 'IN',
                                    dial_code: '91',
                                    primary_phone_verified: false,
                                    is_primary: true,
                                    user_id: this.loggedInUser.user_id,
                                    id: this.communication_data.phone_details[index].id
                                }
                            ];
                        } else {
                            params.phone_details = [
                                {
                                    phone_type: 'primary',
                                    phone_number: this.communication_data.phone_details[index].phone_number.startsWith('+91') ? this.communication_data.phone_details[index].phone_number.split(' ').splice(1,).join('') : this.communication_data.phone_details[index].phone_number,
                                    country_code: 'IN',
                                    dial_code: '91',
                                    primary_phone_verified: false,
                                    is_primary: true,
                                    user_id: this.loggedInUser.user_id,
                                }
                            ];
                        }

                        this.$validator.validate('phone'+index).then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Enter Valid Phone");
                            }
                        });
                    }
                    else if(data == 'alternate_phone_number') {
                        delete params.alternate_emails;
                        if(this.communication_data.phone_details[index].id) {
                            params.phone_details = [
                                {
                                    phone_type: this.communication_data.phone_details[index].phone_type,
                                    phone_number: this.communication_data.phone_details[index].phone_number.startsWith('+91') ? this.communication_data.phone_details[index].phone_number.split(' ').splice(1,).join('') : this.communication_data.phone_details[index].phone_number,
                                    country_code: 'IN',
                                    dial_code: '91',
                                    primary_phone_verified: false,
                                    is_primary: false,
                                    id: this.communication_data.phone_details[index].id
                                }
                            ];
                        } else {
                            // if(this.communication_data.phone_details.length == 2) {
                            //     params.phone_details = [
                            //         {
                            //             phone_type: this.communication_data.phone_details[0].phone_type,
                            //             phone_number: this.communication_data.phone_details[0].phone_number.startsWith('+91') ? this.communication_data.phone_details[0].phone_number.split(' ').splice(1,).join('') : this.communication_data.phone_details[0].phone_number,
                            //             country_code: 'IN',
                            //             dial_code: '91',
                            //             primary_phone_verified: this.communication_data.phone_details[0].primary_phone_verified ? true : false,
                            //             is_primary: true,
                            //         },
                            //         {
                            //             phone_type: this.communication_data.phone_details[index].phone_type,
                            //             phone_number: this.communication_data.phone_details[index].phone_number.startsWith('+91') ? this.communication_data.phone_details[index].phone_number.split(' ').splice(1,).join('') : this.communication_data.phone_details[index].phone_number,
                            //             country_code: 'IN',
                            //             dial_code: '91',
                            //             primary_phone_verified: false,
                            //             is_primary: false,
                            //         }
                            //     ];
                            // } else {
                                params.phone_details = [
                                    {
                                        phone_type: this.communication_data.phone_details[index].phone_type,
                                        phone_number: this.communication_data.phone_details[index].phone_number.startsWith('+91') ? this.communication_data.phone_details[index].phone_number.split(' ').splice(1,).join('') : this.communication_data.phone_details[index].phone_number,
                                        country_code: 'IN',
                                        dial_code: '91',
                                        primary_phone_verified: false,
                                        is_primary: false,
                                    }
                                ];
                            // }
                        }
                        this.$validator.validate('alternate_phone'+index).then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Enter Valid Alternate Phone");
                            }
                        });
                    }
                    else if(data == 'social_media') {
                        delete params.alternate_emails;
                        if(this.communication_data.social_media[index].id) {
                            params.social_media = [
                                {
                                    account_type: this.communication_data.social_media[index].account_type.type,
                                    account_url: this.communication_data.social_media[index].account_url,
                                    icon_url: this.communication_data.social_media[index].account_type.icon_url,
                                    id: this.communication_data.social_media[index].id,
                                    user_id: this.loggedInUser.user_id
                                }
                            ];
                        } else {
                            params.social_media = [
                                {
                                    account_type: this.communication_data.social_media[index].account_type.type,
                                    icon_url: this.communication_data.social_media[index].account_type.icon_url,
                                    account_url: this.communication_data.social_media[index].account_url,
                                }
                            ];
                        }
                        this.$validator.validate('social_account_url'+index).then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Enter Valid url");
                            }
                        });
                    }
                    else if(data == 'emergency_contact_name') {
                        delete params.alternate_emails;
                        if(this.communication_data.emergency_contact[index].id) {
                            params.emergency_contact = [
                                {
                                    contact_name: this.communication_data.emergency_contact[index].contact_name,
                                    id: this.communication_data.emergency_contact[index].id
                                }
                            ];
                        } else {
                            params.emergency_contact = [
                                {
                                    contact_name: this.communication_data.emergency_contact[index].contact_name,
                                }
                            ];
                        }
                        this.$validator.validate('emergency_contact_name'+index).then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Enter Emergency Contact Name");
                            }
                        });
                    }
                    else if(data == 'emergency_number') {
                        delete params.alternate_emails;
                        if(this.communication_data.emergency_contact[index].id) {
                            params.emergency_contact = [
                                {
                                    contact_number: this.communication_data.emergency_contact[index].contact_number,
                                    id: this.communication_data.emergency_contact[index].id
                                }
                            ];
                        } else {
                            params.emergency_contact = [
                                {
                                    contact_number: this.communication_data.emergency_contact[index].contact_number,
                                }
                            ];
                        }
                        this.$validator.validate('emergency_number'+index).then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Enter Emergency Number");
                            }
                        });
                    }
                    else if(data == 'emergency_relationship') {
                        delete params.alternate_emails;
                        if(this.communication_data.emergency_contact[index].id) {
                            params.emergency_contact = [
                                {
                                    contact_relationship: this.communication_data.emergency_contact[index].contact_relationship,
                                    id: this.communication_data.emergency_contact[index].id
                                }
                            ];
                        } else {
                            params.emergency_contact = [
                                {
                                    contact_relationship: this.communication_data.emergency_contact[index].contact_relationship,
                                }
                            ];
                        }
                        this.$validator.validate('emergency_relationship'+index).then(async result => {
                            if (result) {
                                let response = await this.addUpdateCommunication(params, this.loggedInUser.user_id);
                                if(response.status_id == 1) {
                                    this.getCommunicationData();
                                }
                            }
                            else {
                                // console.log("Select Relationship");
                            }
                        });
                    }
                }
                catch(err) {
                    // console.log(err);
                }
            },
            async deleteSocialMedia(id, index) {
                if(id) {
                    try {
                        let param = id;
                        let response = await this.deleteCommunicationSocialMediaById(param);
                        if(response.status_id == 1) {
                            this.getCommunicationData();
                        }
                    }
                    catch(err) {
                        // console.log(err);
                    }
                } else {
                    this.communication_data.social_media.splice(index,1);
                }
            },
            async getDropdownsDataByType(type, index) {
                if(type == 'social_media') {
                    this.editValue('account_url', index);
                }
                else if(type == 'relationship') {
                    this.editValue('emergency_relationship', index);
                }
                this.dropdown_loading = true;
                try {
                    let params = type;
                    let response = await this.getDropdownsData(params);
                    if(response.status_id == 1) {
                        if(type == 'social_media') {
                            this.social_media_type_options = response.response;
                        }
                        else if(type == 'relationship') {
                            this.emergency_relationship_options = response.response;
                        }
                    }
                    this.dropdown_loading = false;
                }
                catch(err) {
                    // console.log(err);
                }
            }
        },
        mounted() {
            this.getCommunicationData();
        },
        watch: {
            emergency_contact_checkbox_all: function (newval, oldval) {
                if(newval == true) {
                    this.checkedCheckbox = [];
                    this.communication_data.emergency_contact.forEach((contact,index)=>{
                        if(contact.id != undefined || contact.id != null) {
                            this.checkedCheckbox.push(contact.id);
                        }
                    })
                } else {
                    this.checkedCheckbox = [];
                }
            }
        },
        created() {
            const dict = {
                custom: {
                    alternate_email_input:{
                        email: () => "Please enter valid Email Address",
                    },
                    social_account_url: {
                        regex: () => "Enter valid Acoount URL."
                    },
                    phone: {
                        min: () => "Enter valid Phone Number."
                    },
                    alternate_phone: {
                        min: () => "Enter valid Alternate Phone Number."
                    }
                }
            };
            this.$validator.localize("en", dict);
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            // account() {
            //     return this.$store.getters.account;
            // },
            // selectedCompany() {
            //     return this.$store.getters.selectedCompany;
            // },
        },
    };
</script>

<style>
    .validation {
        color: red
    }
    .teleContact{
        background-color: white !important;
    }
    .teleContact > input{
        background-color: white !important;
        width: 100%;
        padding-right: 50px;
    }
    .teleContact > input:hover{
        background-color: white !important;
    }
    .teleContact:hover,
    .teleContact {
        background-color: white !important;
    }
    .teleContact .dropdown:hover,
    .teleContact .dropdown {
        background-color: white !important;
    }
    .teleContact1 > input{
        width: 300px
    }
    .digi-multiselect{
        border-bottom: 0px;
    }
    .vue-tel-input > .dropdown{
        padding: 5px !important
    }
</style>


// WEBPACK FOOTER //
// src/components/ContactCommunicationView.vue